const isMicrosoftBrowser = (userAgent: any) => {
  const userAgentPatterns = ['MSIE ', 'Trident/', 'Edge/']

  return new RegExp(userAgentPatterns.join('|')).test(userAgent)
}

const ROUNDING_TOLERANCE = isMicrosoftBrowser(window.navigator.userAgent) ? 1 : 0

const hasScrollableSpace = (element: any, axis: any) => {
  if (axis === 'Y') {
    return element.clientHeight + ROUNDING_TOLERANCE < element.scrollHeight
  }

  if (axis === 'X') {
    return element.clientWidth + ROUNDING_TOLERANCE < element.scrollWidth
  }
}

const canOverflow = (element: any, axis: any) => {
  const overflowValue = (window.getComputedStyle(element, null) as any)[`overflow${axis}`]

  return overflowValue === 'auto' || overflowValue === 'scroll'
}

const isScrollable = (element: any) => {
  const isScrollableY = hasScrollableSpace(element, 'Y') && canOverflow(element, 'Y')
  const isScrollableX = hasScrollableSpace(element, 'X') && canOverflow(element, 'X')

  return isScrollableY || isScrollableX
}

const findScrollableParent = (element: any) => {
  let node = element

  while (node !== document.body && !isScrollable(node)) {
    node = node.parentNode || node.host
  }

  return node === document.body ? null : node
}

/**
 * Функция для скролла ближайшего родителя до переданного элемента
 * Отличие от нативного element.scrollIntoView() или библиотечного "scroll-into-view"
 * В том, что данная функция скролит только ближайшего родителя, в отличие от нативного
 * И библиотечного, которые скролят все элементы с overflow выше по дереву
 */
export const scrollTopIntoView = (elem: any) => {
  if (!elem) {
    return
  }

  const scrollableParent = findScrollableParent(elem)

  if (scrollableParent === null) {
    return
  }

  const parentRects = scrollableParent.getBoundingClientRect()
  const elemRects = elem.getBoundingClientRect()

  const topOverflow = Math.round(parentRects.top) - Math.round(elemRects.top)
  const bottomOverflow = Math.round(elemRects.bottom) - Math.round(parentRects.bottom)

  const isTopOverflow = topOverflow > 0
  const isBottomOverflow = bottomOverflow > 0

  if (!isTopOverflow && !isBottomOverflow) {
    return
  }

  const yScroll = scrollableParent.scrollTop + (isTopOverflow ? -topOverflow : bottomOverflow)

  scrollableParent.scrollTo(0, yScroll)
}
